export const requiredData = {
  unlicensedStates: [
    "IN",
    "NV",
    "UT",
    "VT",
    "WI",
    "PR",
    "NY",
    "AK",
    "CA",
    "KS",
    "MD",
    "MA",
    "NH",
    "RI",
    "TN",
  ],

  footer: `Guild Mortgage needs the contact information you provided to us to contact you about your reverse mortgage loan inquiry. By checking this box, you agree to be contacted by Guild Mortgage. You may unsubscribe from communications with Guild at any time by contacting Guild Mortgage directly. You hereby consent, acknowledge and agree to the privacy policy and agree to receive notices and other communication electronically. You consent to receive text messages and auto-dialed and/or pre-recorded telemarketing calls, texts, voicemails (which may use artificial voices and may be recorded), from Guild Mortgage regarding your inquiry and other home-related matters, and that they may contact you at the telephone number provided here, including your wireless number, if applicable, even if that telephone number is on a corporate, state, or national Do Not Call Registry. You understand that you can elect to not receive such calls or messages at any time, and that consent is not a condition of purchase. You understand that msg/data rates may apply. You agree that your data may be used for marketing and analytics, and to make your experience easier. For SMS message campaigns: Text STOP to (866)362-7999 to stop and HELP for help. Msg & data or carrier rates may apply. You confirm you have received and reviewed the Mortgage Broker Disclosures for your state.`,
};

export async function checkValid(handleUpdateFormValue, zipCode) {
  let city;
  let state;

  try {
    const response = await fetch(
      `https://data.bankradar.com/legacy/zipcode/${zipCode}/`
    );
    const data = await response.json();
    city = data.city;
    state = data.statecode;
  } catch {
    handleUpdateFormValue(
      "errorMessage",
      "Error validating zip code, please try again."
    );
  }

  if (!city || city.length === 0) {
    handleUpdateFormValue(
      "errorMessage",
      "Please enter a valid 5 digit zip code."
    );
    return {
      isValidState: false,
      redirect: false,
    };
  }

  if (requiredData.unlicensedStates.includes(state)) {
    return {
      isValidState: false,
      redirect: true,
    };
  }

  handleUpdateFormValue("state", state);
  handleUpdateFormValue("city", city);
  handleUpdateFormValue("errorMessage", "");

  return {
    isValidState: true,
    redirect: false,
  };
}

export const progress = {
  Age: 0,
  Zip: 1,
  "Home Value": 2,
  "Mtg Balance": 3,
  Address: 4,
  "Manual Address": 4,
  "Full Name": 5,
  Email: 6,
  Phone: 7,
  TFA: 8,
  Result: 9
};
